export default __webpack_public_path__ + "static/media/Dime.95be2419.png";